import React from 'react';

import './categories.scss';
import cn from 'classnames';

const Categories = ({ categories, setSelectCategory, selectCategoryName }) => (
	<div className="categories container">
		<div className="row item-row polygon" />
		{categories.map((category, index) => (
			<div className="category-wrapper">
				<div
					className={cn(`category posit${index + 1}`, {
						select: selectCategoryName === category.value.categoryname
					})}
					onClick={() => setSelectCategory(category)}
				>
					<img
						className="img"
						src={
							selectCategoryName === category.value.categoryname
								? process.env.REACT_APP_API_ENDPOINT +
								  category.value.selectCategoryicon.path
								: process.env.REACT_APP_API_ENDPOINT +
								  category.value.categoryicon.path
						}
						alt="teste"
					/>
					<p className="label">{category.value.categoryname}</p>
				</div>
			</div>
		))}
	</div>
);
export default Categories;
